import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import FooterMenu from "./common/FooterMenu";
import ShareOptions from "./common/ShareOptions";
import { fetchInitialData } from "../../fetchData";
import Service from '../../service/Service';
import * as actions from './actions';
import Cookies from "js-cookie";
import withContext from "../../../withContext";

const service = new Service();

class GroceryList extends Component {
    constructor(props) {
        super(props);
        let serverSideData = {};
        let ingredientsArrData = [];
        let initialData = [];
        let isApp = '';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['msg'] == 1 && serverSideData['result']) {
            initialData = serverSideData;
            ingredientsArrData = serverSideData['result'];
        }
        console.log("ingredientsArrData====>", ingredientsArrData);
        console.log("serverSideData", serverSideData);
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        this.state = {
            initialData: initialData,
            ingredientsArrData: ingredientsArrData,
            metaTitle: "Grocery List: Baby & Toddlers Meal Plans - FirstCry Parenting",
            metaDescription: [],
            norecordFound: false,
            isApp : isApp
        };
        this.qnaPageNo = 1;
        this.totalCount = this.state.initialData.totalcount;
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {

        var LatestFtk = '';
        if (cookieData && (cookieData.includes("app_ftk"))) {
            var cookieAry = cookieData.split(';');
            for (var i = 0; i < cookieAry.length; i++) {
                if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                    LatestFtk = cookieAry[i].split('app_ftk=')[1];
                }
            }
        }
        console.log("LatestFtk=====>", LatestFtk);

        var url = global.api_url + "dietplan/getgrocerylist";
        var header = {
            'Content-Type': 'application/json',
            'ftk': (ftk!="")?ftk:LatestFtk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let body = JSON.stringify({
            "pageno": 1,
            "pagesize": 10
        });
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        console.log("initialData=====>", this.state.initialData);
        console.log("ingredientsArrData=====>", this.state.ingredientsArrData);
        this.setState({ windowWidth: window.outerWidth });
        document.addEventListener("click", this.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (this.state.isApp) {
            actions.loadCallbackFile();
            document.querySelector('.footerList').style.bottom = "0px";
            // setTimeout(() => {
                if (!this.state.ingredientsArrData || this.state.ingredientsArrData =="record not found" || this.state.ingredientsArrData.length < 1) {
                    this.setState({norecordFound:true},()=>{document.querySelector('.NoRecordsCont').style.display = "block";this.heightScroll()});
                }else{
                    this.setState({norecordFound:false},()=>{this.heightScroll()});
                }
            // }, 200);
        } else {
            document.querySelector('.data-container').style.minHeight = "unset";
            if (!this.state.ingredientsArrData || this.state.ingredientsArrData == "record not found" || this.state.ingredientsArrData.length < 1) {
                this.setState({ norecordFound: true }, () => { document.querySelector('.NoRecordsCont').style.display = "block" });
            }
        }

        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                this.groceryList(1,10);
                service.showLoader();
            } else {
                localStorage.setItem('groceryList', JSON.stringify(this.state.initialData));
            }
        } else {
            if (localStorage.getItem('groceryList')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('groceryList')),
                    ingredientsArrData: JSON.parse(localStorage.getItem('groceryList'))['result']
                });
                this.totalCount = JSON.parse(localStorage.getItem('groceryList'))['totalcount'];
            }
            service.hideLoader();
        }
        // console.log("windowWidth--", window.outerWidth);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
        window.removeEventListener("scroll", this.pageData, false);
    }
    groceryList(pageno, size) {
        var postData = {
            "pagesize": size,
            "pageno": pageno
        }
        var url = global.api_ci_url + "MealPlanner/groceryList";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ initialData: json, ingredientsArrData: json['result'] }, () => { this.heightScroll();
                    service.hideLoader();
                });
                this.totalCount = json['totalcount'];
            } else {
                if (document.querySelector(".gloceryCon") == null || document.querySelectorAll(".gloceryCon").length == 0) {
                    document.querySelector(".disclaimer-con") && (document.querySelector(".disclaimer-con").style.display = "none");
                    this.setState({ norecordFound: true });
                    document.querySelector('.NoRecordsCont').style.display = "block";
                    if (this.state.isApp && document.querySelectorAll(".gloceryCon").length == 0) {
                        this.onLoadScroll();
                    }
                }
                
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    groceryListScroll(pageno, size) {
        var postData = {
            "pagesize": size,
            "pageno": pageno
        }
        var url = global.api_ci_url + "MealPlanner/groceryList";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.ingredientsArrData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ ingredientsArrData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.ingredientsArrData;
                        this.setState({ ingredientsArrData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                }else {
                    localStorage.setItem('groceryList', JSON.stringify(json));
                    localStorage.setItem('initialData', JSON.stringify(json));
                    localStorage.setItem('ingredientsArrData', JSON.stringify(json['result']));
                    this.totalCount = parseInt(json['totalcount']);
                    this.setState({ mealSelRecp: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            } else {
                if (document.querySelector(".gloceryCon") == null || document.querySelectorAll(".gloceryCon").length == 0) {
                    document.querySelector(".disclaimer-con") && (document.querySelector(".disclaimer-con").style.display = "none");
                    this.setState({ norecordFound: true });
                    document.querySelector('.NoRecordsCont').style.display = "block";
                    if (this.state.isApp && document.querySelectorAll(".gloceryCon").length == 0) {
                        this.onLoadScroll();
                    }
                }
                
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                var checkVal = _this.state.isApp ? ((window.innerHeight + window.scrollY) > document.body.offsetHeight) : ((window.innerHeight + window.scrollY) >= document.body.offsetHeight);
                if (!(checkVal) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        service.showTracking();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.groceryListScroll(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }
    domClick(event) {
        console.log("event Dom========>", event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }

        }
        if (event.target.classList.contains('childProfile_overlay2')) {
            document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'none';
        }

    }
    openMealPopupSlider(event, e) {
        document.querySelector('.mp-slider').style.display = 'none';
        for (let i = 1; i < 4; i++) {
            if (document.getElementById('mp-slider' + i).style.display == 'block') {
                document.getElementById('mp-slider' + i).style.display == 'none';
            }
        }
        if (e == 'up') {
            document.getElementById('mp-slider' + event).style.display = 'block';
            document.getElementById('mpup' + event).style.display = 'none';
            document.getElementById('mpdown' + event).style.display = 'block';
        } else {
            document.getElementById('mpdown' + event).style.display = 'none';
            document.getElementById('mp-slider' + event).style.display = 'none';
            document.getElementById('mpup' + event).style.display = 'block';
        }
    }
    closechildPopup(cls) {
        document.getElementsByClassName(cls)[0].style.display = 'none';
    }
    changeData(id, type, status, updateData) {
        let ingredientsArrData = this.state.ingredientsArrData;
        ingredientsArrData && ingredientsArrData.forEach((ingredients) => {
            if (ingredients.recipeid == id) {
                if (type == "removeList") {
                    if (parseInt(status) == 0) {
                        ingredients.list = updateData;
                        var grouceryList = document.querySelectorAll(".gloceryCon").length;
                        if (grouceryList == 2 || document.querySelectorAll(".gloceryCon").length == 1) {
                            this.groceryList(1, 10);
                        }
                    }
                }
            }
        });
        service.hideLoader();
        this.setState({ ingredientsArrData: ingredientsArrData },()=>{
            if (this.state.ingredientsArrData && document.querySelector(".glocery-container") && document.querySelector(".glocery-container")!=null) {
                var eleHeigth = document.querySelector(".glocery-container").clientHeight;
                var minheightdata = window.innerHeight - 120;
                if (document.querySelector(".glocery-container").scrollHeight + 40 < minheightdata){
                    // document.querySelector('.disclaimer-con').style.paddingBottom = "39px";
                    document.querySelector('.disclaimer-con').style.marginBottom = "31px";
                    document.querySelector('.disclaimer-con').style.width = "100%";
                    document.querySelector('.disclaimer-con').style.position = "fixed";
                    document.querySelector('.disclaimer-con').style.bottom = "40px";
                    document.querySelector('.data-container').style.background = "#fff";
                }
            }
        });
    }
    heightScroll(){
        var flagNo = this.state.norecordFound;
        var flagT = this.state.ingredientsArrData.length;
        if (flagT >= 1 && this.state.ingredientsArrData != "record not found") {
            this.setState({ norecordFound: false });
            var minheightdata = window.innerHeight - 50;
            document.querySelector('.data-container').style.minHeight = minheightdata + "px";
            document.querySelector('.footerList').style.bottom = "0px";
            document.querySelector('.sub-container').style.height = "auto";
            // document.querySelector('.sub-container') && (document.querySelector('.sub-container').style.marginBottom = "65px");
            document.querySelector('.sub-container').style.marginBottom = "0";
            document.querySelector('.main-container') && (document.querySelector('.main-container').style.background = "#eee");
            document.querySelector('.data-container').style.paddingBottom = "35px";
            document.querySelector('.disclaimer-con').style.marginBottom = "6px";
            if (this.state.isApp && this.state.ingredientsArrData && document.querySelector(".glocery-container")) {
                // var eleHeigth = document.querySelector(".glocery-container").clientHeight;
                var minheightdata = window.innerHeight - 120;
                if (document.querySelector(".glocery-container").scrollHeight + 40 < minheightdata){
                    // document.querySelector('.disclaimer-con').style.paddingBottom = "39px";
                    document.querySelector('.sub-container').style.marginBottom = "0";
                    document.querySelector('.disclaimer-con').style.marginBottom = "31px";
                    document.querySelector('.disclaimer-con').style.width = "100%";
                    document.querySelector('.disclaimer-con').style.position = "fixed";
                    document.querySelector('.disclaimer-con').style.bottom = "40px";
                    document.querySelector('.data-container').style.background = "#fff";
                }
            }
        } else {
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.main-container').style.background = "#FFF");
            // var scheight = screen.height - 80 - 50;
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.sub-container').style.height = scheight + "px");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.minHeight = "auto");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.height = "100%");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.height = "100%");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.glocery-container').style.height = "100%");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.padding = "40% 1px");
            // document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.background = "#fff");

            this.onLoadScroll();
        }
    }
    onLoadScroll() {
        document.querySelector('.NoRecordsCont').style.display = "block";
        document.querySelector('.NoRecordsCont') && (document.querySelector('.main-container').style.background = "#fff");
        var scheight = screen.height - 80 - 50;
        document.querySelector('.NoRecordsCont') && (document.querySelector('.sub-container').style.height = scheight + "px");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.minHeight = "auto");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.height = "100%");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.height = "100%");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.glocery-container').style.height = "100%");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.NoRecordsCont').style.padding = "40% 1px");
        document.querySelector('.NoRecordsCont') && (document.querySelector('.data-container').style.background = "#fff");
    }
    render() {
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp &&
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={global.redirect_url + "tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>Grocery List</span>
                        </div>
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>Grocery List</h1>
                    </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                        <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Grocery List</span>
                    </div>
                }
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        <div className="glocery-container">
                            {this.state.initialData && this.state.initialData['msg'] != -1 && this.state.ingredientsArrData && this.state.ingredientsArrData.length > 0 && this.state.ingredientsArrData.map((ingredient, index) =>
                                <div key={index}>
                                    {ingredient && ingredient.list && ingredient.list.length > 0 &&
                                        <div id={"screenShot_"+index} className="gloceryCon">
                                            <div className="headblc">
                                                <div className="block1 left">
                                                    <div className="gtitle M15_48 left">{ingredient.recname}</div>
                                                    {/* <div className="gtype R11_9e left">({ingredient.recType})</div> */}
                                                </div>
                                                <div className="block2 left">
                                                    <div className="card-share right social-actions">
                                                        <div className="R13_61 right share-icon" onClick={(e) => actions.shareOn(e, index, this.state.isApp, "", ingredient.recname , "GorceryList", "", "", "",ingredient)}>
                                                            <div className="fb-icon left">
                                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" alt="Facebook" title="Facebook" />
                                                            </div>
                                                            <div data-icon-font="" className="whtapp-icon left"></div>
                                                            <div className="left share-txt R13_61">Share</div>
                                                        </div>

                                                        <ShareOptions eleRef={this} index={index} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="ginfo">
                                                {ingredient && ingredient.list && ingredient.list.length > 0 && ingredient.list.map((ingredients, index1) =>
                                                    <div key={index1} className="groc-div">
                                                        <div className="bullet left"></div>
                                                        <div className="grocname left R13_61">{ingredients.ingredient}</div>
                                                        <div className="addmin right" onClick={() => { actions.addIngrediants(ingredients.id, ingredients.isChecked, ingredients.ingredient, "GL", this, ingredient.recipeid, this.state.isApp) }}>
                                                            <span className="R11_9e minicon" data-icon-font="Z"></span>
                                                        </div>
                                                    </div>
                                                )
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            )}
                            {this.state.norecordFound &&
                                <div className="NoRecordsCont">
                                    <div className="recordImg">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/GroceryListEmpty.png" />

                                    </div>
                                    <div className="recoedText">Seems like you haven't selected any ingredient from the recipe list to add here in grocery list.</div>
                                </div>
                            }
                            <input type="hidden" id="pgNo" value="" />

                            <div className="childProfile_overlay2">
                                <div className="popup tbmargin">
                                    <span className="close_icon icon right R14_9e" data-icon-font="C" onClick={() => { this.closechildPopup("childProfile_overlay2") }}></span>
                                    <div className="agetext R14_42">There are no items in grocery list</div>
                                </div>
                            </div>

                        </div>
                        <FooterMenu eleRef={this} flag="GL" isApp={this.state.isApp} />
                    </div>
                </div>
                <div className="share-overlay"></div>
                <div className="new-right-sect">
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(GroceryList);
